import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class RouteParamsService {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
  ) {
  }

  updateRouteParams(queryParamsObj, route) {
    this.router.navigate(['.'],
      { relativeTo: route,
        queryParams: { ...this.route.snapshot.queryParams, ...this.mapJSONObjToStringify(queryParamsObj) }, replaceUrl: true });
  }

  mapJSONStringifyToObject(queryParams) {
    let queryParamsObj = {};

    Object.entries(queryParams).forEach(([key, value]) => {
      if (typeof value === 'string') {
        queryParamsObj = { ...queryParamsObj, [key]: JSON.parse(value)};
      }
    });

    return queryParamsObj;
  }

  mapJSONObjToStringify(queryParams) {
    let queryParamsObj = {};
    Object.entries(queryParams).forEach(([key, value]) => {
      queryParamsObj = { ...queryParamsObj, [key]: JSON.stringify(value)};
    });

    return queryParamsObj;
  }
}
